import { render } from "./InterfaceUpdateSnackbar.vue?vue&type=template&id=afbeeb64&scoped=true"
import script from "./InterfaceUpdateSnackbar.vue?vue&type=script&lang=js"
export * from "./InterfaceUpdateSnackbar.vue?vue&type=script&lang=js"

import "./InterfaceUpdateSnackbar.vue?vue&type=style&index=0&id=afbeeb64&scoped=true&lang=scss"

import exportComponent from "/tmp/ee6909f6-e1a9-41e2-8541-cccc71f1c53b/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afbeeb64"]])

export default __exports__